export default __webpack_public_path__ + "static/Postgresql_elephant.svg-c8891cc79d21bc263a06462dad6742b3.png";